import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSafetyChecklistPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useSafetyChecklistSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getSafetyChecklistSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.safety_checklist_page?.safety_checklist_section}`);
      console.log("🚀 ~ getSafetyChecklistSectionJson ~ data:", response);
      console.log("🚀 ~ getSafetyChecklistSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setSafetyChecklistPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Safety Checklists section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getSafetyChecklistSectionJson();
  }, [getSafetyChecklistSectionJson]);

  return {
    data,
    loading,
    error,
    getSafetyChecklistSectionJson,
    fetchOnMount,
    refetch: getSafetyChecklistSectionJson
  };
};

export default useSafetyChecklistSection;
